<template>
  <button
    class="appearance-none rounded-full bg-transparent w-10 h-10 p-2 -my-1"
    :style="`--color: ${colorStr}`"
    @click="$emit('click', color)"
  >
    <div
      v-if="selectedColor === color"
      class="selected rounded-full h-full border-2"
      :data-testid="`annotations-color-${colorStr}-selected`"
    >
      <div class="inner rounded-full h-full" />
    </div>
    <div v-else class="nonselected rounded-full h-full" :data-testid="`annotations-color-${colorStr}`" />
  </button>
</template>

<script lang="ts" setup>
import type { AnnotationColors } from '@/lib/annotations/constants'
import { colorToString } from '@/lib/annotations/constants'

const props = defineProps({
  color: {
    type: Number as PropType<AnnotationColors>,
    required: true,
  },
  selectedColor: {
    type: Number,
    required: true,
  },
})

defineEmits(['click'])

const colorStr = computed(() => colorToString(props.color))
</script>

<style lang="stylus" scoped>
.selected
  border-color var(--color)
  padding 2px
  .inner
    background-color var(--color)
.nonselected
  background-color var(--color)
</style>
